import { type Context, createContext } from 'react';

/**
 * @public
 */
export interface ModalContextProps {
  parent: ModalContextProps | null;
  modalCount: number;
  addModal: () => void;
  removeModal: () => void;
}

/**
 * @public
 */
export const ModalContext: Context<ModalContextProps | null> =
  createContext<ModalContextProps | null>(null);
ModalContext.displayName = 'ModalContext';
